import React, { FC } from "react";
import { Tag, Row } from "antd";
import styled from "styled-components";
import { CatalogItem } from "../../queries/auto-generated/schemas";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../ducks";
import Variation from "./variation";
import catalog from "../../ducks/catalog";
import _ from "lodash";
import { cardContentPadding } from "./item";

const VariationGroup: FC<{
  catalogItem: CatalogItem;
}> = ({ catalogItem }) => {
  const dispatch = useDispatch();

  const selections = useSelector(
    (state: RootState) => state.catalog.currentItemSelectionChoices
  );
  const allVariations = useSelector(
    (state: RootState) => state.catalog.data.variations
  );
  const variations = catalogItem.variations?.map(
    (v) => allVariations[v?.id ?? ""]
  );

  const ordinalSorted = _.sortBy(variations, [(o) => o?.ordinal]);

  const instructions = "Select 1 option";
  const errorMessage = `Please do the following: ${instructions}`;

  return (
    <Container padding={cardContentPadding}>
      <Title>Different recipes</Title>
      <Tag color="volcano">Required</Tag>
      <div>{instructions}</div>
      <ErrorMessage visible={selections?.error ?? false}>
        {errorMessage}
      </ErrorMessage>

      <Row gutter={[12, 12]}>
        {ordinalSorted?.map((variation) => {
          const selected = selections?.variation_id === variation?.id;
          return (
            <Variation
              variation={variation}
              selected={selected}
              toggleSelected={() =>
                dispatch(
                  catalog.actions.updateSelectionVariation({
                    itemId: catalogItem.id,
                    variationId: variation.id,
                  })
                )
              }
            />
          );
        })}
      </Row>
    </Container>
  );
};

const Container = styled.div<{ padding: string }>`
  padding: ${(p) => p.padding};
`;
const Title = styled.h3`
  display: inline-block;
  padding-right: 1em;
`;
const ErrorMessage = styled.div<{ visible: boolean }>`
  color: red;
  visibility: ${(p) => (p.visible ? "initial" : "hidden")};
`;

export default VariationGroup;
